import React from 'react';
import PropTypes from "prop-types";
import { LastArticleSmall } from './LastArticleSmall';

export const BlogLatestArticles = props => {

    const { articlesList, languagePrismic } = props;

    return (
        <section className="panel-latest-articles">
            <div className=" container">
                <h4 className="h4 ">Latest articles</h4>
                <ul className="panel-latest-articles__list row">
                    {
                        articlesList && articlesList.length > 0 ? articlesList.map(article => {
                            return <LastArticleSmall
                                key={article.uid}
                                uid={article.uid}
                                title={article.title}
                                small_img={article.small_img}
                                short_description={article.short_description}
                                date={article.date}
                                alternative_text_image={article.alternative_text_image}
                                languagePrismic={languagePrismic}
                            />
                        }) : null
                    }
                </ul>
            </div>
        </section>
    );
};

BlogLatestArticles.propTypes = {
    articlesList: PropTypes.array,
    languagePrismic: PropTypes.object
};



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/BlogLatestArticles.js